import api from '../config/Api';

const endpoint = 'v1/entity';

export default {

  getPurchaseLicenses( entityId, params ) {
    return api.get( `${endpoint}/${entityId}/purchase-license`, params );
  },

  savePurchaseLicense( entityId, data ) {
    return api.post( `${endpoint}/${entityId}/purchase-license`, data );
  },
};
